import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from 'src/components/mui-overrides/Checkbox';

interface Props {
  disabled?: boolean;
}

export const BrokerageFeeForEndCustomersCheckbox: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <CheckboxField
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.brokerageFeeForEndCustomers')}
      fieldName="investmentDetails.brokerageFeeForEndCustomers"
      disabled={disabled}
    />
  );
};
